import _isEmpty from 'lodash/isEmpty';
const getEnabledCreditApp = _ref => {
  let {
    dealDetails = {},
    ownerCreditApp = {},
    existingDeal = {},
    enableSACACreditApp = false,
    enableSDPCreditApp = false
  } = _ref;
  const isCreditAppSubmittedForOwner = !_isEmpty(ownerCreditApp);
  let isSDPEnabled = false;
  let isCreditAppSubmittedForListing = false;
  const {
    id: existingDealId
  } = existingDeal;
  const hasExistingDeal = !!existingDealId;
  if (hasExistingDeal) {
    isCreditAppSubmittedForListing = dealDetails?.[existingDealId]?.creditApp?.creditAppSubmittedFlag;
  }
  if (enableSDPCreditApp) {
    isSDPEnabled = !isCreditAppSubmittedForListing;
  }
  return {
    isSACAEnabled: !!enableSACACreditApp && !isCreditAppSubmittedForOwner,
    isSDPEnabled
  };
};
export { getEnabledCreditApp as default };
